module.exports = __webpack_public_path__ + "static/media/20-FILES-.efe702e4.jpg";